<template>
  <b-card>
    <validation-observer
      ref="simpleRules"
    >
      <b-form @submit.prevent>
        <b-row>
          <b-col md="6">
            <b-form-group
              label="O que sera cobrado?"
              label-for="charge"
            >
              <validation-provider
                #default="{ errors }"
                name="O que sera cobrado"
                rules="required"
              >
                <b-form-input
                  id="charge"
                  v-model="req.product.name"
                  placeholder="informe o nome do produto "
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-row>
              <b-col
                md="12"
                lg="6"
              >
                <b-form-group
                  label="Valor total"
                  label-for="value"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Valor total"
                    rules="required|value"
                  >
                    <b-form-input
                      id="value"
                      v-model="value"
                      v-money
                      placeholder="insira o valor total da venda "
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                md="12"
                lg="6"
              >
                <b-form-group
                  label="Quantidade"
                  label-for="quantity"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Quantidade"
                    rules="required|integer"
                  >
                    <b-form-input
                      id="quantity"
                      v-model="req.product.amount"
                      v-mask="'####'"
                      placeholder="insira a quantidade total de produtos"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                md="12"
                lg="6"
              >
                <b-form-group
                  label="Nome do pagador"
                  label-for="name"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Nome do Pagador"
                    rules="required"
                  >
                    <b-form-input
                      id="name"
                      v-model="novalue.name"
                      :readonly="readOnlyCustomer"
                      placeholder="informe o nome do pagador "
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                md="12"
                lg="6"
              >
                <b-form-group
                  label="Documento do pagador"
                  label-for="document"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Documento do pagador"
                    :rules="`required|${isForeigner ? '' : 'document'}`"
                  >
                    <b-form-input
                      id="document"
                      v-model="novalue.tax_id"
                      v-mask="isForeigner ? ['#################'] : [
                        '###.###.###-##',
                        '##.###.###/####-##',
                        '##.###.###',
                      ]"
                      :readonly="readOnlyCustomer"
                      placeholder="informe o documento do pagador "
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                md="12"
                lg="6"
              >
                <b-form-group
                  label="Nº Máximo de Parcelas"
                  label-for="v-installments"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Número máximo de parcelas"
                    rules="required|integer"
                  >
                    <b-form-select
                      id="v-installments"
                      v-model="req.payment.installments"
                      :disabled="disabledInstallments"
                      :options="installmentObject"
                      :state="errors.length > 0 ? false : null"
                      @change="createChargeAfterInstallments()"
                    />
                    <small class="text-danger">
                      {{ errors[0] }}
                    </small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                md="12"
                lg="6"
                sm="12"
                v-if="!lockCard"
              >
                <b-form-group
                  label="Cobrar juros a partir da parcela"
                  label-for="ChargeAfterIntallment"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Cobrar juros a partir da parcela"
                    rules="required"
                  >
                    <b-form-select
                      id="v-ChargeAfter"
                      v-model="req.payment.charge_after"
                      :disabled="readOnlyChargeAfter"
                      :options="chargeAfterObject"
                      :state="errors.length > 0 ? false : null"
                      @change="chargeAfterCheck()"
                    />
                    <small class="text-danger">
                      {{ errors[0] }}
                    </small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>

          <b-col md="6">
            <b-form-group
              label="Descrição (opcional)"
              label-for="description"
              type="text-area"
              placeholder="digite a descrição do produto "
            >
              <validation-provider
                #default="{ errors }"
                name="Descrição"
              >
                <textarea
                  id="exampleFormControlTextarea1"
                  v-model="req.product.description"
                  class="form-control"
                  rows="2.9"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group
              label="E-mail do pagador"
              label-for="email"
            >
              <validation-provider
                #default="{ errors }"
                name="E-mail"
                rules="required|email"
              >
                <b-form-input
                  id="email"
                  v-model="novalue.email"
                  :readonly="readOnlyCustomer"
                  placeholder="Informe o email do pagador"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group
              label-for="ChargeAfter"
              label="Juros"
              v-if="!lockCard"
            >
              <validation-provider
                #default="{ errors }"
                name="Juros"
                :rules="rulesChargeAfter"
              >
                <b-form-input
                  id="v-ChargeAfter"
                  v-model="req.payment.charge_rate"
                  v-mask="['#%', '#,#%', '#,##%']"
                  placeholder="Informe a taxa de juros"
                  :readonly="readOnlyChargeRate"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group class="mb-1">
              <div class="d-flex align-items-center">
                <b-form-checkbox
                  id="is-foreigner"
                  v-model="isForeigner"
                  class="mr-2"
                >
                  Cliente é estrangeiro?
                </b-form-checkbox>

                <b-form-checkbox
                  v-if="shouldShowLockCard"
                  v-model="lockCard"
                >
                  Cliente é Centurion?
                </b-form-checkbox>
              </div>
            </b-form-group>
          </b-col>
        </b-row>
        <b-button
          variant="primary"
          class="button-generate btn-primary"
          @click="validationForm()"
        >
          Gerar
        </b-button>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BFormSelect,
  BCard,
  BFormCheckbox,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'
import Ripple from 'vue-ripple-directive'
import { generateLink } from '@/service/transaction-generator/transaction-generator'
import { callLoading } from '@/service/utilities/utilities'
import MerchantService from '@/service/merchant'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BCard,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },
  props: {
    customer: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      required,
      merchantData: null,
      lockCard: false,
      isForeigner: false,
      email,
      value: 0.01,
      disabledInstallments: true,
      readOnlyCustomer: false,
      id: null,
      checker: false,
      readOnlyChargeAfter: true,
      response: null,
      rulesChargeAfter: ' ',
      readOnlyChargeRate: true,
      installmentObject: [],
      chargeAfterObject: [{
        value: 0,
        text: 'Não cobrar juros',
      }],
      req: {
        product: {
          name: null,
          amount: null,
          description: null,
        },
        payment: {
          value: 0,
          installments: 1,
          charge_rate: null,
          charge_after: 0,
        },
      },
      novalue: {
        name: null,
        email: null,
        tax_id: null,
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: true,
      },
    }
  },
  computed: {
    maxInstallments() {
      if (!this.merchantData?.merchants) return 12

      const extendedInstallmentECs = [2923,2922,92]
      const hasExtendedInstallments = this.merchantData.merchants.some(merchant =>
        extendedInstallmentECs.includes(Number(merchant.veripag_id))
      )

      return hasExtendedInstallments ? 21 : 12
    },

    shouldShowLockCard() {
    if (!this.merchantData?.merchants) return false

    const allowedECs = [2647, 2920, 3021, 3025,92] 

    const result = this.merchantData.merchants.some(m =>
      allowedECs.includes(m.veripag_id)
    )
    return result
    }
  },

  watch: {
    value(currentValue) {
      const value = +currentValue.replace(/[R$.]/g, '').replace(',', '.')

      if (value >= 10) {
        this.disabledInstallments = false
        this.readOnlyChargeAfter = false
        this.chargeAfterCheck()
      } else {
        this.disabledInstallments = true
        this.readOnlyChargeAfter = true
        this.req.payment.installments = 1
        this.req.payment.charge_after = 0
        this.req.payment.charge_rate = null
        this.readOnlyChargeRate = true
        this.rulesChargeAfter = null
      }
    },
    lockCard(isCenturion) {
    if (isCenturion) {
      if (this.req.payment.installments > 4) {
        this.req.payment.installments = 4
      }

      this.req.payment.charge_after = 0
      this.req.payment.charge_rate = null
      this.readOnlyChargeRate = true
      this.readOnlyChargeAfter = true
      this.rulesChargeAfter = ''

      this.installmentObject = []
      for (let i = 1; i <= 4; i += 1) {
        this.installmentObject.push({
          value: i,
          text: i,
        })
      }
    } else {
      this.installmentObject = []
      for (let i = 1; i <= this.maxInstallments; i += 1) {
        this.installmentObject.push({
          value: i,
          text: i,
        })
      }
      this.readOnlyChargeAfter = false
    }
  },
  },
  async created() {
    await this.getMerchant()
    this.id = this.$route.query.cliente
    this.verifyObject()

    const maxInstallment = this.maxInstallments
    for (let installment = 1; installment < maxInstallment + 1; installment += 1) {
      this.installmentObject.push({
        value: installment,
        text: installment,
      })
    }
  },
  methods: {
    async verifyObject() {
      if (this.customer.isTrue) {
        this.readOnlyCustomer = true
        this.req.customer_id = this.customer.customer_id
        this.novalue.name = this.customer.name
        this.novalue.email = this.customer.email
        this.novalue.tax_id = this.customer.tax_id
      }
    },
    error() {
      this.$swal({
        title: 'Não foi possivel criar a venda direta!',
        icon: 'error',
        timer: 2000,
        showConfirmButton: false,
        buttonsStyling: false,
      })
    },
    errorCatch(error) {
      this.$swal({
        title: error,
        icon: 'error',
        timer: 2000,
        showConfirmButton: false,
        buttonsStyling: false,
      })
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.createPaymentLink()
        }
      })
    },
     async getMerchant() {
      try {
        const service = new MerchantService()
        const response = await service.getChildren()
        this.merchantData = response
      } catch (err) {
        console.log('Erro ao buscar merchant:', err)
      }
    },
    createChargeAfterInstallments() {
      const { installments } = this.req.payment
      this.chargeAfterObject = [
        {
          value: 0,
          text: 'Não cobrar juros',
        },
      ]
      for (let saleInstallmentsAvailable = 1; saleInstallmentsAvailable <= installments; saleInstallmentsAvailable += 1) {
        this.chargeAfterObject.push({
          value: saleInstallmentsAvailable,
          text: saleInstallmentsAvailable,
        })
      }
    },
    chargeAfterCheck() {
      const { charge_after } = this.req.payment

      if (!charge_after) {
        this.readOnlyChargeRate = true
        this.req.payment.charge_rate = null
        this.rulesChargeAfter = ''
      } else {
        this.rulesChargeAfter = 'required|ValidatorFees'
        this.readOnlyChargeRate = false
      }
    },
    async createPaymentLink() {
      callLoading(true)
      const merchantId = Number(sessionStorage.getItem('veripagID'))
      if (!Number.isInteger(merchantId) || merchantId <= 0) {
        callLoading(false)
        this.$router.push({ name: 'select-merchant' })
        return
      }

      if (!this.customer.isTrue) {
        this.req.customer = {
          name: this.novalue.name,
          email: this.novalue.email,
          tax_id: this.novalue.tax_id,
        }
      }

     if (!this.req.payment.charge_rate) { this.req.payment.charge_rate = 0 } else {
        this.req.payment.charge_rate = this.req.payment.charge_rate.replace(',', '.')
        this.req.payment.charge_rate = parseFloat(this.req.payment.charge_rate.split('%')[0])
      }

      this.req.payment.value = +this.value.replace(/[R$.]/g, '').replace(',', '.')

      this.req.merchant_id = merchantId

      if (this.shouldShowLockCard) {
        this.req.payment.lock_card = this.lockCard
      }
      try {
        const response = await generateLink('payment-link', this.req)
        if (response.status === 200) {
          this.hash = `${response.data.link.hash}`
          this.$router.push(`/venda-direta/confirmado/${this.hash}`)
        } else {
          this.error()
        }
      } catch (err) {
        this.errorCatch(err)
      } finally {
        callLoading(false)
      }
    },
  },
}
</script>

<style scoped lang="scss">
@import "@core/scss/base/pages/page-link-generator.scss";
</style>
